import { render, staticRenderFns } from "./SettingTenantList.vue?vue&type=template&id=01ae23c3&"
import script from "./SettingTenantList.vue?vue&type=script&lang=ts&"
export * from "./SettingTenantList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports